export default __webpack_public_path__ + "static/media/i3.88f9eec2.jpeg";